<script lang="ts">
	// Genuine shadcn-svelte Badge (CLI-fetched), RESTYLED to price-check tokens +
	// the project's status variants. The variant map + type live in
	// ./badge-variants.ts so plain `tsc` can resolve them. The dynamic per-brand
	// mfg/match chips stay as helper-computed inline styles, not variants.
	// NO arbitrary `[..]` values.
	import type { HTMLAnchorAttributes } from "svelte/elements";
	import { cn, type WithElementRef } from "../../../utils.js";
	import { badgeVariants, type BadgeVariant } from "./badge-variants.js";

	let {
		ref = $bindable(null),
		href,
		class: className,
		variant = "default",
		children,
		...restProps
	}: WithElementRef<HTMLAnchorAttributes> & {
		variant?: BadgeVariant;
	} = $props();
</script>

<svelte:element
	this={href ? "a" : "span"}
	bind:this={ref}
	data-slot="badge"
	{href}
	class={cn(badgeVariants({ variant }), className)}
	{...restProps}
>
	{@render children?.()}
</svelte:element>
